<template>
  <Form ref="webSiteForm" :model="webSite" v-loading="loading" :disabled="actionType=='detail'" :rules="ruleValidate" :label-width="100" >
     <input v-model="webSite.id" type="hidden"/>

    <FormItem  :label="this.$t('cms.website.code.label')" prop="code">
      <Input v-model="webSite.code" :disabled="actionType=='edit'" :placeholder="$t('cms.website.code.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('cms.website.name.label')" prop="name">
      <Input v-model="webSite.name" :placeholder="$t('cms.website.name.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('cms.website.logoUrl.label')" prop="logoUrl">
      <Input v-model="webSite.logoUrl" :placeholder="$t('cms.website.logoUrl.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('cms.website.publishUrl.label')" prop="publishUrl">
      <Input v-model="webSite.publishUrl" :placeholder="$t('cms.website.publishUrl.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('cms.website.resRoot.label')" prop="resRoot">
      <Input v-model="webSite.resRoot" :placeholder="$t('cms.website.resRoot.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('cms.website.defaultFlag.label')" prop="defaultFlag">
      <i-switch v-model="webSite.defaultFlag"  :placeholder="this.$t('cms.website.defaultFlag.holder')" >
         <span v-for="item in $t('dictionary.boolean.yesOrNo')" :value="item.value" :key="item.value" :slot="item.slot">{{ item.label }}</span>
      </i-switch>
    </FormItem>

    <FormItem  :label="this.$t('cms.website.defWorkflowId.label')" prop="defWorkflowId">
      <Input v-model="webSite.defWorkflowId" :placeholder="$t('cms.website.defWorkflowId.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('cms.website.memo.label')" prop="memo">
      <Input v-model="webSite.memo" :placeholder="$t('cms.website.memo.holder')"  type="textarea" :rows="3"/>
    </FormItem>

    <FormItem  :label="this.$t('cms.website.status.label')" prop="status">
      <Select v-model="webSite.status" :placeholder="$t('cms.website.status.holder')">
        <Option v-for="item in $t('cms.website.status.dictionary')" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
    </FormItem>

    <FormItem  :label="this.$t('cms.website.sort.label')" prop="sort">
      <InputNumber v-model="webSite.sort" :placeholder="$t('cms.website.sort.holder')"/>
    </FormItem>

  </Form>
</template>
<script>
import api from '@/api'

export default {
  data () {
    return {
      webSite: {
        id: null,
        code: null,
        name: null,
        logoUrl: null,
        publishUrl: null,
        resRoot: null,
        defaultFlag: true,
        defWorkflowId: null,
        memo: null,
        status: 1,
        deptId: null,
        createTime: null,
        creator: null,
        updateTime: null,
        updater: null,
        sort: 100,
        deleted: null,
        tenantId: null,
        version: 1
      },
      loading: false,
      actionType:'add'
    }
  },
  methods: {
    handleSubmit(then,error){
      this.$refs['webSiteForm'].validate(valid => {
        if (valid) {
          if (this.webSite.id) {
            this.updateWebSite(this.webSite).then(then).error(error)
          } else {
            this.createWebSite(this.webSite).then(then).error(error)
          }
        } else {
          this.$Message.error(this.$t('errorText'))
          error()
        }
      })
    },
    handleReset(){
      this.webSite.id = ''
      this.actionType = 'add';
      this.$nextTick(()=>this.$refs['webSiteForm'].resetFields());
    },
    getWebSite(id,type){
      this.loading = true;
      this.$refs['webSiteForm'].resetFields()
      api.cms.WebSite.detail(id).then(data => {
        this.webSite = data;
        this.loading = false;
        this.actionType = type;
      }).catch(e => this.loading = false)
    },
    createWebSite(webSite){
      this.loading = true;
      return api.cms.WebSite.add(webSite)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    },
    updateWebSite(webSite){
      this.loading = true;
      return api.cms.WebSite.update(webSite)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    }
  },
  computed: {
    ruleValidate(){
      let validate =  {
      code: [{type: 'string', required: true, message: this.$t('cms.website.code.required'),trigger: 'blur'}, {type: 'string',min: 6, message: this.$t('cms.website.code.min'),trigger: 'blur'}, {type: 'string',max: 64, message: this.$t('cms.website.code.max'),trigger: 'blur'}],
      name: [{type: 'string', required: true, message: this.$t('cms.website.name.required'),trigger: 'blur'}, {type: 'string',min: 10, message: this.$t('cms.website.name.min'),trigger: 'blur'}, {type: 'string',max: 128, message: this.$t('cms.website.name.max'),trigger: 'blur'}],
      logoUrl: [{type: 'string',max: 128, message: this.$t('cms.website.logoUrl.max'),trigger: 'blur'}],
      publishUrl: [{type: 'string',max: 128, message: this.$t('cms.website.publishUrl.max'),trigger: 'blur'}],
      resRoot: [{type: 'string',max: 128, message: this.$t('cms.website.resRoot.max'),trigger: 'blur'}],
      defaultFlag: [{type: 'boolean', required: true, message: this.$t('cms.website.defaultFlag.required'),trigger: 'blur'}],
      defWorkflowId: [{type: 'string',max: 64, message: this.$t('cms.website.defWorkflowId.max'),trigger: 'blur'}],
      memo: [{type: 'string', required: true, message: this.$t('cms.website.memo.required'),trigger: 'blur'}, {type: 'string',max: 512, message: this.$t('cms.website.memo.max'),trigger: 'blur'}],
      status: [{type: 'number', required: true, message: this.$t('cms.website.status.required'),trigger: 'blur'}],
      sort: [{type: 'number', required: true, message: this.$t('cms.website.sort.required'),trigger: 'blur'}, {type: 'number', min: 0, message: this.$t('cms.website.sort.min'),trigger: 'blur'}, {type: 'number', max: 127, message: this.$t('cms.website.sort.max'),trigger: 'blur'}]
      }
      if(this.actionType == 'edit'){
        this.$refs['webSiteForm'].fields.forEach(f => {
          if(f.$children[0].disabled){
            delete validate[f.prop]
          }
        })
      }else if(this.actionType == 'detail'){
        return {}
      }
      return validate;
    }
  }
}
</script>
